import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { clearDeprecatedTierKeys } from './utils/migrateTierKeys';
import { activateDevDialsFromUrl } from './utils/devDials';

// Purge orphaned pre-rewrite Tier Builder keys before any state reads them, so
// stale drags can't keep feeding usePricing / the mock-draft AI tier sheets.
clearDeprecatedTierKeys();

// Dev-only feel-pass activation (?dials=...). Must run before the first render,
// because it mutates the module-scope engine knobs that usePricing and the bid
// engine read. No-op in production — see utils/devDials.js.
activateDevDialsFromUrl();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
